export default "__VITE_ASSET__71272f5c__"